import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectFilterOptions, SelectModule } from 'primeng/select';
import { AutoFocusModule } from 'primeng/autofocus';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'dd-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  imports: [
    FormsModule,
    SelectModule,
    AutoFocusModule
  ]
})
export class SabisGrid2EditorComponent implements OnChanges {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  public options: any[] = [];
  public optionLabelName: string = '';
  public selectedOption: any = null;

  public isLoading: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['record'] || changes['column']) {
      if (!this.column.comboSettings) {
        throw 'this.column.comboSettings cannot be null';
      }

      this.optionLabelName = this.column.comboSettings.textField;
      this.options = this.column.comboSettings.data as any[];
      this.selectedOption = this.options.find(o => o[this.column.comboSettings!.valueField] === this.record[this.column.field]);
    }
  }

  public onModelChange(change: any): void {
    this.record![this.column.field] = change[this.column.comboSettings!.valueField];
  }

  public onFilterChanged(event: KeyboardEvent, options: SelectFilterOptions) {
    if (!options.filter) {
      return;
    }

    options.filter(event);
  }
}
